import React from 'react';

import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {InputChangeEvent} from 'util/Types';

export default function ExpirationCheckbox(props: {
  isWritable: boolean;
  onUpdate: (isEnabled: boolean) => void;
  isChecked: boolean;
}): JSX.Element {
  return (
    <div>
      <div className="u-flex-display">
        <CheckboxInput
          id="toggle-expiration-checkbox"
          label=""
          checked={props.isChecked}
          onChange={(e: InputChangeEvent) => {
            props.onUpdate(e.target.checked);
          }}
          disabled={!props.isWritable}
        />
        <FieldLabel label="Enable expiration date tracking" />
      </div>
      <div className="u-padding-left u-base-text">
        {/* Keep in sync with back-end
        `ImplementedExpirationTrackingSchemaInterfaceHandler:HELP_TEXT_FOR_ADDING_INTERFACE_TO_EXISTING_SCHEMA` */}
        Add “Expiration date” as a system field on all containers holding entities of this schema. This cannot
        be disabled once it is enabled.
      </div>
    </div>
  );
}
